import { PENSION_ANNUITY_LIMITS } from "shared/CalculatorLimits";
import { getAmountField } from "web_myplann/Calculators/Forms/getAmountField";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";
import { z } from "zod";

export const getPensionAnnuityFormSchema = (t: TranslateFunction) =>
	z.object({
		annuity: getAmountField(t, { max: PENSION_ANNUITY_LIMITS.annuityMax }),
		deposit: getAmountField(t, {
			min: 0,
			max: PENSION_ANNUITY_LIMITS.depositMax,
		}),
		duration: z.number(),
		yearsUntil: z.number(),
	});
